export default __webpack_public_path__ + "static/media/coming soon2-01-01-01.d0bd4135.png";